import { EventDate } from 'src/types/ViewModel/EventDate';
import { getDateFromISO } from 'odfjell-date-time-utils/dateTimeUtils';

/**
 * Creates an EventDate object from planned and actual date/time strings
 */
export const createEventDate = (plannedDateTimeUtc: string | null, actualDateTimeUtc: string | null): EventDate => {
    const eventDate: EventDate = {
        plannedDateTimeUtc: getDateFromISO(plannedDateTimeUtc),
        actualDateTimeUtc: getDateFromISO(actualDateTimeUtc),
        plannedDateTimeLocal: null,
        actualDateTimeLocal: null,
    };
    return eventDate;
};
